import React from "react";
import { MainHeader } from "../../components/global/MainHeader";
import { Socials } from "../../components/Home/Socials";
import { CheckoutBody } from "../../components/Checkout/CheckoutBody";

export const Checkout = () => {
  return (
    <React.Fragment>
      <MainHeader name={"Checkout"} />
      <CheckoutBody />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};
